import React, { FC, useState } from "react";
import styles from "./FestivalEscapeFrame.module.scss";
import { Card, CardContent, CardMedia } from "@mui/material";
import "swiper/css";
import "swiper/css/navigation";
import RightSideArrow from "../icons/RightSideArrow";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslations } from "next-intl";
import { ElementDecrator, NextSwiperArrow, PrevSwiperArrow } from "../icons";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
interface CarouselItem {
  id: number;
  alt: string;
  img: string;
}

interface PromoCard {
  id: number;
  image: string;
  title: string;
  description: string;
  ctaText: string;
  ctaColor: string;
}

interface HeroSection {
  heading: string;
  subtitle: string;
  ctaText: string;
}

interface FestivalEscapeFrameProps {
  carouselItems: CarouselItem[];
  promoCards: PromoCard[];
  heroSection: HeroSection;
}

const FestivalEscapeFrame: FC<FestivalEscapeFrameProps> = ({ promoCards }) => {
  const t = useTranslations("");
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const router = useRouter();
  const isRtl = router.locale === "ar";
  const handleSwiper = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const handleSlideChange = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div className="inline-flex flex-col items-center c-lg:gap-16 gap-6 relative">
      {/* Hero Section */}
      {/* <section className="relative w-[1312px]">
        <div className="relative w-full h-[631px]">
          <div className="absolute w-full h-[542px] top-0 ltr:left-0 rtl:right-0 rounded-[20px] bg-[url(/images/FestivalDestination/img.png)] bg-cover bg-center">
            <div className="flex flex-col  items-start relative top-[307px] ltr:left-[30px] rtl:right-[30px]">
              <h1 className="text-white font-bold text-[32px] leading-[86px]">
                           {heroSection.heading}

              </h1>
              <div className="flex items-center gap-[45px] -mt-8">
                <p className="text-white text-lg leading-[86px] whitespace-nowrap">
                                  {heroSection.subtitle}

                </p>
                <button
                  className="p-0 text-white gap-2 flex items-center"
                >
                  <span className="text-white text-lg font-bold">
                    {heroSection.ctaText}
                  </span>
<RightSideArrow className="text-white rtl:scale-[-1]" />
                </button>
              </div>
            </div>
          </div>

          <div className="absolute w-[1312px] h-[170px] top-[461px] ltr:left-[15px] rtl:right-[15px]">
            <Swiper
 dir={rtl ? "rtl" : "ltr"}
slidesPerView={5}
              spaceBetween={15}
              navigation={{
                nextEl: ".swiper-button-next-custom",
                prevEl: ".swiper-button-prev-custom",
              }}
              modules={[Navigation]}
              className="mySwiper"
              onSwiper={handleSwiper}
              onSlideChange={handleSlideChange}
            >
              {carouselItems.map((item) => (
                <SwiperSlide key={item.id}>
                  <div className="h-full rounded-lg overflow-hidden bg-gray-200">
                    <img
                      src={item.img}
                      alt={item.alt}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div
            className={`swiper-button-prev-custom transition-opacity duration-200 !top-[85%] ${
              isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              height="32"
              width="32"
              aria-hidden="true"
              fill="currentcolor"
              role="img"
              focusable="false"
              className="Svg-sc-12lgb6u-0 EQfAR ChevronLeft__SvgChevronLeft-sc-1pih41b-0 dvOXuG"
            >
              <path d="M15.4 16.6L10.8 12l4.6-4.6L14 6l-6 6 6 6 1.4-1.4z"></path>
            </svg>
          </div>
          <div
            className={`swiper-button-next-custom transition-opacity duration-200 !top-[85%] ${
              isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              height="32"
              width="32"
              aria-hidden="true"
              fill="currentcolor"
              role="img"
              focusable="false"
              className="Svg-sc-12lgb6u-0 kRLFlm ChevronRight__SvgChevronRight-sc-ec4b4o-0 ktEMtW"
            >
              <path d="M8 16.6l4.6-4.6L8 7.4 9.4 6l6 6-6 6L8 16.6z"></path>
            </svg>
          </div>
        </div>
      </section> */}
      <div className="flex flex-row items-center justify-between relative self-stretch w-full max-w-[1328px] mx-auto px-4">
        <h1 className=" w-fit font-bold  c-lg:text-4xl text-2xl ">
          {t(`Top summer deals for you`)}
        </h1>
      </div>

      <section className="relative w-full max-w-[1140px] mx-auto ">
        <div className="absolute inset-x-0 top-[76px] w-full h-[430px]  bg-[#fcf9f1] rounded-[20px] z-0" />
        <div className="relative z-10 flex  flex-row justify-center gap-[30px] px-[30px] pt-[76px] -mt-20 mb-20">
          <div
            className={`swiper-button-prev-custom swiper-button-prev-custom-D transition-opacity duration-200 ${
              isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
          >
            <PrevSwiperArrow />
          </div>
          <div
            className={`swiper-button-next-custom swiper-button-next-custom-D  transition-opacity duration-200 ${
              isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
          >
            <NextSwiperArrow />
          </div>

          <div className="overflow-hidden max-w-[1312px]">
            <Swiper
              dir={isRtl ? "rtl" : "ltr"}
              key={isRtl ? "rtl" : "ltr"}
              spaceBetween={16}
              slidesPerView={1}
              slidesPerGroup={1}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 16,
                  centeredSlides: true,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                },
              }}
              navigation={{
                nextEl: ".swiper-button-next-custom-D",
                prevEl: ".swiper-button-prev-custom-D",
              }}
              modules={[Navigation]}
              className="mySwiper1"
              onSwiper={handleSwiper}
              onSlideChange={handleSlideChange}
            >
              {promoCards.map((card) => (
                <SwiperSlide key={card.id} className="!rounded-[10px]">
                  <Card
                    key={card.id}
                    className="w-full max-w-[525px]  h-[473px]  !rounded-[10px] !shadow-[0_0_35px_rgba(212,175,55,0.07)] overflow-hidden"
                  >
                    <CardMedia
                      component="img"
                      image={card.image}
                      alt={`Promotional image ${card.id}`}
                      className="h-[275px] object-cover"
                    />
                    <CardContent className="flex flex-col gap-[15px] pt-8 px-[30px]">
                      <h2 className="c-lg:text-2xl text-base font-bold text-primary ">
                        {card.title}
                      </h2>
                      <p className="c-lg:text-lg text-base text-primary ">
                        {card.description}
                      </p>
                      <Link
                        href="#"
                        className="inline-flex items-center gap-2 text-start mt-auto text-secondary font-bold !text-sm"
                      >
                        {t(`Learn More`)}{" "}
                        <RightSideArrow className="rtl:rotate-180" />
                      </Link>
                    </CardContent>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      
      </section>
    </div>
  );
};

export default FestivalEscapeFrame;
